import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getRecommendedComics } from '@/mocks/comics';

export default function RecommendedSection() {
  const recommendedComics = getRecommendedComics();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              编辑<span className="text-primary-600">推荐</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">精选优质韩漫，每一部都值得阅读</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {recommendedComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}